<template>
    <v-dialog v-model="props.dialog_parent" max-width="750px" persistent>
        <v-card>
            <v-card-title class="bg-cyan-darken-2">
                <h2 class="text-h4 text-center">Armas</h2>
            </v-card-title>

            <v-card-title>
                <span class="text-h5">
                    <v-icon icon="mdi-pencil" size="samll" color="cyan-darken-2 as-scale"></v-icon>
                    {{ props.formTitleParent }}
                </span>
            </v-card-title>

            <v-container>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="props.registro_parent.id_arma" color="cyan-darken-2" label="Id_Arma" :rules="[
                            () => !!props.registro_parent.id_arma || required_message,
                        ]" :error-messages="getValidationErrors('id_arma')"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="props.registro_parent.codigo_arma" color="cyan-darken-2" label="Codigo Arma"
                            :rules="[
                                () => !!props.registro_parent.codigo_arma || required_message,
                            ]" :error-messages="getValidationErrors('codigo_arma')"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <label for="">Tipo de Arma</label>
                        <p>{{  props.registro_parent.codigo_tipo }}</p>
                        <select v-model="props.registro_parent.codigo_tipo" class="form-select" id="selectOption">
                            <option v-for="item in optionstipoarma" :key="item.codigo_tipo" :value="item.codigo_tipo">
                                {{ item.descripcion }}
                            </option>
                        </select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="props.registro_parent.marca_arma" color="cyan-darken-2" label="Marca" :rules="[
                            () => !!props.registro_parent.marca_arma || required_message,
                            (v) =>
                                !!/^\d+$/.test(v) ||
                                'El Numero de identidad solo debe contener caracteres numéricos.',
                        ]" :error-messages="getValidationErrors('marca_arma')"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="props.registro_parent.modelo_arma" color="cyan-darken-2" label="Modelo"
                            :rules="[
                                () => !!props.registro_parent.modelo_arma || required_message,
                            ]" :error-messages="getValidationErrors('modelo_arma')"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <label for="selectOption">Seleccione el Calibre: </label>
                        <select v-model="props.registro_parent.codigo_calibre" class="form-select" id="selectOption"
                            aria-label="Default select example">
                            <!-- <option selected>Calibre</option> -->
                            <option v-for="item in optionscalibre" :key="item.codigo_calibre" :value="item.codigo_calibre">
                                {{ item.codigo_calibre }} - {{ item.descripcion }}
                            </option>
                        </select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="props.registro_parent.cargadores" color="cyan-darken-2"
                            label="Cant. Cargadores" :rules="[
                                () =>
                                    !!props.registro_parent.cantidad_cargadores ||
                                    required_message,
                                (v) =>
                                    !!/^\d+$/.test(v) ||
                                    'El Numero de referencia solo debe contener caracteres numéricos.',
                            ]" :error-messages="getValidationErrors('cantidad_cargadores')"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">

                        <label for="selectOption">Seleccione el Pais de Procedencia: </label>
                        <select v-model="props.registro_parent.codigo_procedencia" class="form-select" id="selectOption"
                            aria-label="Default select example">
                            <option v-for="item in optionsprocedencia" :key="item.codigo_origen"
                                :value="item.codigo_origen">
                                {{ item.codigo_origen }} - {{ item.descripcion }}
                            </option>
                        </select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <label for="selectOption">clasificacion: </label>
                        <select v-model="props.registro_parent.codigo_clasificacion" class="form-select" id="selectOption"
                            aria-label="Default select example">
                            <!-- <option selected>Calibre</option> -->
                            <option v-for="item in optionsclasificacion" :key="item.codigo_clasificacion"
                                :value="item.codigo_clasificacion">
                                {{ item.codigo_clasificacion }} - {{ item.descripcion }}
                            </option>
                        </select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="props.registro_parent.observaciones" color="cyan-darken-2"
                            label="Observaciones" :rules="[
                                () => !!props.registro_parent.observaciones || required_message,
                                (v) =>
                                    !!/^\d+$/.test(v) ||
                                    'El Numero de referencia solo debe contener caracteres numéricos.',
                            ]" :error-messages="getValidationErrors('observaciones')"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-checkbox v-model="props.registro_parent.status" :error-messages="getValidationErrors('status')"
                            value="1" label="Estado" type="checkbox"></v-checkbox>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn variant="outlined" @click="closeDialogChild()" color="red">
                    <v-icon icon="mdi-file-cancel-outline"></v-icon>&nbsp;Cancelar
                </v-btn>
                <v-btn color="cyan-darken-1" variant="outlined" @click="saveChild()">
                    <v-icon icon="mdi-content-save-check-outline"></v-icon>&nbsp;Actualizar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import Selects from "@/services/Selects";

export default defineComponent({
    props: [
        "dialog_parent",
        "registro_parent",
        "formTitleParent",
        "errors_validate_parent",
    ],
    emits: ["closeDialogParent", "saveParent"],

    setup(props, { emit }) {
        const closeDialogChild = () => {
            emit("closeDialogParent");
        };
        const saveChild = () => {
            console.log("Selected codigo_tipo:", props.registro_parent.codigo_tipo);
            emit("saveParent");
        };
        return { props, closeDialogChild, saveChild };
    },
    data() {
        return {
            optionstipoarma: [],
            optionsprocedencia: [],
            optionsclasificacion: [],
            optionscalibre: [],
        };
    },
    async mounted() {
        const selecttipoarm = new Selects();  //--3
        const datatipoarm = await selecttipoarm.loadDataTipoArma2();  //--3
        this.optionstipoarma = datatipoarm;  //--3
        console.log("Datos cargados:", datatipoarm);  //--3
        const selectcalibre = new Selects();  //--2
        const datacalibre = await selectcalibre.loadDataCalibres2();  //--2
        this.optionscalibre = datacalibre;   //--2
        console.log("Datos cargados:", datacalibre);  //--2
        const selectprocedencia = new Selects();  //--4
        const dataprocedencia = await selectprocedencia.loadDataProcedencia2();  //--4
        this.optionsprocedencia = dataprocedencia;  //--4
        console.log("Datos cargados:", dataprocedencia);  //--4
        const selectclasificacion = new Selects();  //--5
        const dataclasificacion = await selectclasificacion.loadDataClasificacionarma2();  //--5
        this.optionsclasificacion = dataclasificacion;  //--5
        console.log("Datos cargados:", dataclasificacion);  //--5
    },

    computed: {
        getValidationErrors() {
            return function (property) {
                if (
                    this.props.errors_validate_parent &&
                    this.props.errors_validate_parent[property]
                ) {
                    return this.props.errors_validate_parent[property][0];
                }
                return "";
            };
        },
    },
});
</script>
